export const ROOT = 'common/user';

export const CREATE_USER_REQUEST = `${ROOT}/CREATE_USER_REQUEST`;
export const CREATE_USER_FAILURE = `${ROOT}/CREATE_USER_FAILURE`;
export const CREATE_USER_SUCCESS = `${ROOT}/CREATE_USER_SUCCESS`;

export const SET_USER_PAYMENT = `${ROOT}/SET_USER_PAYMENT`;
export const SET_USER_PASARELLA = `${ROOT}/SET_USER_PASARELLA`;
export const SET_USER_NAME = `${ROOT}/SET_USER_NAME`;
export const SET_USER_TOKEN = `${ROOT}/SET_USER_TOKEN`;
export const SET_USER_LOGIN = `${ROOT}/SET_USER_LOGIN`;

export const PUT_USER_REQUEST = `${ROOT}/PUT_USER_REQUEST`;
export const PUT_USER_FAILURE = `${ROOT}/PUT_USER_FAILURE`;
export const PUT_USER_SUCCESS = `${ROOT}/PUT_USER_SUCCESS`;